import useTranslation from "next-translate/useTranslation";
import React from "react";
import { useDispatch } from "react-redux";
import { setPrix } from "redux/slices/carteprixReducer";
import formatUrl from "utils/FormatUrl";
import { buildUrl } from "../../PrixImmoRouterUrlHelper";
import PricesDisplaySqueleton from "./AveragePriceAreaComponents/PricesDisplaySqueleton";
import styles from "./AveragePricesList.module.css";

let matches =
  typeof window !== "undefined" &&
  window.matchMedia("(min-width: 990px)").matches;

export default function AveragePricesList({
  type,
  titre,
  scrollingUp,
  prices,
  loadingPrices,
}: {
  scrollingUp: () => void;
  prices: {
    _id: string;
    prix_appartement: number;
    prix_villa: number;
    province: string;
    region: string;
    commune: string;
    province_ar: string;
    indice_confiance_appartement: number;
    indice_confiance_villa: number;
    lat: number;
    lng: number;
  }[];
  titre: string;
  type: "provinces" | "communes";
  loadingPrices: boolean;
}) {
  const { t, lang } = useTranslation("prixImmobilierMaroc");

  const dispatch = useDispatch();

  return (
    <>
      {loadingPrices ? (
        <PricesDisplaySqueleton t={t} />
      ) : (
        <div
          className={styles.villes_list__container}
          style={{
            direction: lang == "ar" ? "rtl" : "ltr",
            textAlign: lang == "ar" ? "right" : "left",
            minHeight: `${prices.length * 22}px`,
            width: "100%",
          }}
        >
          <div className={styles.villes__title__container}>
            <p className={styles.villes__title}>
              {t("Le prix du m² dans les grandes villes du Maroc")}
            </p>
          </div>
          <div
            className={styles.list__container}
            style={{ minHeight: `${prices.length * 20}px`, width: "100%" }}
          >
            <div
              className={styles.list__inner}
              style={{ minHeight: `${prices.length * 20}px`, width: "100%" }}
            >
              <div
                className={styles.list__villes__container}
                style={{ minHeight: `${prices.length * 20}px`, width: "100%" }}
              >
                <div
                  className={styles.list__villes__inner}
                  style={{
                    minHeight: `${prices.length * 20}px`,
                    width: "100%",
                  }}
                >
                  {prices.map((price) => {
                    let url__ = buildUrl(
                      price.region,
                      price.province,
                      price.commune
                    );
                    return (
                      <div
                        className={styles.list__villes_item__container}
                        style={{ minHeight: `18px` }}
                      >
                        <div
                          className={styles.prices__city__container}
                          style={{ minHeight: `18px` }}
                        >
                          <a
                            rel={
                              url__.includes("list") ||
                              url__.includes("map") ||
                              url__.includes("?") ||
                              url__.includes("conditions") ||
                              url__.includes("contact")
                                ? "nofollow noopener noreferrer noindex"
                                : "follow"
                            }
                            href={formatUrl(
                              buildUrl(
                                price.region,
                                price.province,
                                price.commune
                              ),
                              lang
                            )}
                            className={styles.prices__list}
                            onClick={(e) => {
                              void 0;
                              e.preventDefault();
                              dispatch(
                                setPrix({
                                  data: price,
                                })
                              );
                            }}
                            style={{ minHeight: ` 18px` }}
                            // rel="no-refresh"
                          >
                            {t("Prix immobilier à")}{" "}
                            {t(price.province.replace("-Ida -Ou-Tanane", ""))}
                          </a>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
